<template>
  <div
    class="error-page"
    :style="[
      themeStyle,
    ]"
  >
    <div
      v-for="component in errorStyle.layout.area"
      :key="component.id"
      class="error-area"
    >
      <div
        v-if="component.value === 'html'"
        class="error-content error-html"
      >
        <wang-editor-preview :content="errorStyle.htmlEditor.content" />
      </div>
      <div
        v-if="component.value === 'button'"
        @click="redirect"
      >
        <templateButton
          :btn-config="errorStyle.goHomeButton"
        />
      </div>
      <div
        v-if="component.value === 'text' && themeStyle"
        class="error-content error-text"
      >
        <h1>
          {{ text404 }}
        </h1>
      </div>
      <div
        v-if="component.value === 'image'"
        class="error-content error-image"
      >
        <div class="d-flex d-sm-none justify-content-center align-item-center">
          <div v-if="errorStyle.logosm.image">
            <vue-load-image>
              <b-img
                slot="image"
                :src="`${baseUrl}${supportWebp ? webpImage(errorStyle.logosm.image) : errorStyle.logosm.image}`"
                fluid
                alt="logo-sm"
              />
              <b-img
                slot="preloader"
                :src="require('@/assets/images/items/loading-2.png')"
                fluid
                alt="logo-sm-loading"
              />
            </vue-load-image>
          </div>
          <div v-else-if="errorStyle.logo.image">
            <vue-load-image>
              <b-img
                slot="image"
                :src="`${baseUrl}${supportWebp ? webpImage(errorStyle.logo.image) : errorStyle.logo.image}`"
                fluid
                alt="logo"
              />
              <b-img
                slot="preloader"
                :src="require('@/assets/images/items/loading-2.png')"
                fluid
                alt="logo-loading"
              />
            </vue-load-image>
          </div>
          <div
            v-else
            class="header-default-logo sm"
          >
            <picture>
              <source
                :srcset="require('@/assets/images/items/image.webp')"
                type="image/webp"
              >
              <b-img
                :src="require('@/assets/images/items/image.png')"
                height="60"
                alt="logo"
                class="mb-1"
              />
            </picture>
            <div class="text-center">
              建議：800X600
              <br>
              最小：500X300
            </div>
          </div>
        </div>
        <div class="d-none d-sm-flex justify-content-center align-item-center">
          <div v-if="errorStyle.logo.image">
            <vue-load-image>
              <b-img
                slot="image"
                :src="`${baseUrl}${supportWebp ? webpImage(errorStyle.logo.image) : errorStyle.logo.image}`"
                fluid
                alt="logo"
              />
              <b-img
                slot="preloader"
                :src="require('@/assets/images/items/loading-2.png')"
                fluid
                alt="logo-loading"
              />
            </vue-load-image>
          </div>
          <div v-else-if="errorStyle.logosm.image">
            <vue-load-image>
              <b-img
                slot="image"
                :src="`${baseUrl}${supportWebp ? webpImage(errorStyle.logosm.image) : errorStyle.logosm.image}`"
                fluid
                alt="logo-sm"
              />
              <b-img
                slot="preloader"
                :src="require('@/assets/images/items/loading-2.png')"
                fluid
                alt="logo-sm-loading"
              />
            </vue-load-image>
          </div>
          <div
            v-else
            class="header-default-logo"
          >
            <b-img
              :src="require('@/assets/images/items/image.png')"
              height="60"
              alt="logo"
              class="mb-1"
            />
            <div class="text-center">
              建議：1024X768
              <br>
              最小：650X300
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="errorStyle.layout.area.length === 0"
      class="error-content error-text"
    >
      <h2>
        尚未設定
      </h2>
    </div>
  </div>
</template>

<script>
import {
  VBTooltip, BImg,
  // BTable, BSkeletonTable,
} from 'bootstrap-vue'
import VueLoadImage from 'vue-load-image'
import Ripple from 'vue-ripple-directive'
import dayjs from 'dayjs'

import WangEditorPreview from '@/layouts/components/WangEditorPreview.vue'
import TemplateButton from '../component/TemplateButton.vue'
// import router from '@/router'

export default {
  components: {
    BImg,
    VueLoadImage,
    TemplateButton,
    WangEditorPreview,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themeStyle: null,
      mainText: null,
      text404: '',
    }
  },
  computed: {
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
    windowWidth() {
      return this.$store.state.app.windowWidth
    },
  },
  mounted() {
    this.themeStyle = this.errorStyle.mainText.config
    this.text404 = this.themeStyle['--title-text']
    this.themeStyle['--title-text'] = `"${this.themeStyle['--title-text']}"`
  },
  methods: {
    dayjs,
    // 時間格式
    updateOnline(time) {
      const createTime = Math.floor(new Date(time).getTime() / 1000)
      const createHour = String(new Date(time).getHours())
      const createMinute = String(new Date(time).getMinutes())
      const today = Math.floor(new Date().getTime() / 1000)
      const diffTime = today - createTime
      if (diffTime < 0) return '時間錯誤'
      // 定義單位時間
      const second = 1
      const minute = second * 60
      const hour = minute * 60
      const day = hour * 24
      // 定義換算時間
      let calcTime
      const secondCalc = parseInt(diffTime / second, 10)
      const minuteCalc = parseInt(diffTime / minute, 10)
      const hourCalc = parseInt(diffTime / hour, 10)
      const dayCalc = parseInt(diffTime / day, 10)
      if (dayCalc >= 1 && dayCalc <= 7) {
        if (dayCalc === 1) {
          calcTime = `昨天 ${createHour.padStart(2, '0')}:${createMinute.padStart(2, '0')}`
        } else if (dayCalc === 2) {
          calcTime = `前天 ${createHour.padStart(2, '0')}:${createMinute.padStart(2, '0')}`
        } else {
          calcTime = `${dayCalc} 天前`
        }
      } else if (hourCalc >= 1 && hourCalc <= 23) {
        calcTime = `${hourCalc} 小時前`
      } else if (minuteCalc >= 1 && minuteCalc <= 59) {
        calcTime = `${minuteCalc} 分鐘前`
      } else if (secondCalc >= 1 && secondCalc <= 59) {
        calcTime = `${secondCalc} 秒前`
      } else {
        calcTime = dayjs(time).format('YYYY-MM-DD HH:mm')
      }
      return calcTime
    },
    // (刪減)文字
    shortenTxtLength(txt) {
      if (!txt) return ''
      let resolve = txt
      if (txt.length > 10) {
        txt.substr(0, 10)
        resolve = `${txt.substr(0, 10)}...`
      }
      return resolve
    },
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
    redirect() {
      this.$router.push({ path: '/home.html' })
    },
  },
  setup(props) {
    // #EE1B2E #33CCFF #EE5023 #3C9D40 #8F2A90
    const errorStyle = props.configData.style.base

    return {
      errorStyle,
    }
  },
}
</script>

<style lang="scss" scoped>
$brightness: var(--color-3);
$title-text: var(--title-text);
$letter-spacing: var(--letter-spacing);
$color-deg: var(--color-deg);

// a{
//   color: $link-color;
//   &:hover {
//     text-decoration: none;
//   }
// }

.float:hover {
  transform: translateY(-5px);
}
.brightness:hover {
  filter: brightness(calc(calc(100 + var(--brightness)) * 1%));
}
.opacity:hover {
  opacity: calc(var(--images-brightness) * 1%);
}

.default-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  margin-bottom: 20px;
  max-width: 300px;
  max-height: 300px;
  width: 100%;
  height: 100%;
  border: 2px dashed #dfdfdf;
  border-radius: 10px;
}

.error-page {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 500px;
  height: 100%;
  margin-bottom: 20px;
  position: relative;
  z-index: 100;
}
.error-area {
  width: 100%;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.error-html {
  width: 100%;
}
.error-text {
  h1, h2 {
    position: relative;
    font-weight: 900;
    font-size: clamp(30px, 12vw, 80px);
    letter-spacing: $letter-spacing;
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    background-image: linear-gradient($color-deg, var(--color-1) 30%, var(--color-2));
  }
  h1:before{
    content: var(--title-text);
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    text-shadow: var(--color-3) 1px 0 2px, var(--color-3) 0 1px 2px, var(--color-3) -1px 0 2px, var(--color-3) 0 -1px 2px, var(--color-3) 2px 0 2px, var(--color-3) 0 2px 2px, var(--color-3) -2px 0 2px, var(--color-3) 0 -2px 2px, var(--color-4) 3px 0 3px, var(--color-4) 0 3px 3px, var(--color-4) -3px 0 3px, var(--color-4) 0 -3px 3px, var(--color-4) 5px 0 3px, var(--color-4) 0 5px 3px, var(--color-4) -5px 0 3px, var(--color-4) 0 -5px 3px;
  }
  h2:before {
    content: "尚未設定";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    text-shadow: var(--color-3) 1px 0 2px, var(--color-3) 0 1px 2px, var(--color-3) -1px 0 2px, var(--color-3) 0 -1px 2px, var(--color-3) 2px 0 2px, var(--color-3) 0 2px 2px, var(--color-3) -2px 0 2px, var(--color-3) 0 -2px 2px, var(--color-4) 3px 0 3px, var(--color-4) 0 3px 3px, var(--color-4) -3px 0 3px, var(--color-4) 0 -3px 3px, var(--color-4) 5px 0 3px, var(--color-4) 0 5px 3px, var(--color-4) -5px 0 3px, var(--color-4) 0 -5px 3px;
  }
}
</style>
